import type { AppAction } from '../actions';

export interface NavigationState {
    previousLocation: string | null;
    lastDashboardId: string | null;
}

export const initialState: NavigationState = {
    previousLocation: null,
    lastDashboardId: null,
};

export const navigation = (state = initialState, action: AppAction): NavigationState => {
    switch (action.type) {
        case 'setNavigationState': {
            return {
                previousLocation: action.previousLocation,
                lastDashboardId: action.lastDashboardId,
            };
        }

        case 'setPreviousLocation': {
            return {
                ...state,
                previousLocation: action.previousLocation,
            };
        }

        case 'setLastDashboardId': {
            return {
                ...state,
                lastDashboardId: action.lastDashboardId,
            };
        }

        // Clear navigation state on logout
        case 'refresh-token::clear': {
            return { ...initialState };
        }

        default:
            return state;
    }
};
